import { gql } from "@apollo/client";

export const GET_GUARDS = gql`
  query GetGuards($limit: Int = 10, $offset: Int = 10, $buildingId: uuid) {
    Gaurd(
      limit: $limit
      offset: $offset
      where: {
        Active: { _eq: true }
        Building_Gaurds: { BuildingId: { _eq: $buildingId } }
      }
    ) {
      GaurdFirstName
      Id
      created_at
      password
      Url
      updated_at
    }
    Gaurd_aggregate(
      where: {
        Building_Gaurds: {
          Active: { _eq: true }
          BuildingId: { _eq: $buildingId }
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
